/**
 * The two words `SurveyReading` cannot say for itself.
 *
 * A cell with no answer draws a dash and an expired clip draws a frame, and both owe a reader the
 * word for what they mean. `SurveyReading` is called once per CELL — sixteen thousand of them on a
 * daily check-in over a year — so it must not reach for `t` itself: `useTranslation` subscribes to
 * i18next, and a subscription per cell is a worse cost than the lookup it would save. The three
 * surfaces that draw readings call this ONCE per render and pass the pair down.
 *
 * Two keys rather than a bag, because two is what there are. A third would be the moment to ask
 * whether `SurveyReading` should take a labels object instead.
 */

import { useTranslation } from 'react-i18next';

export interface SurveyReadingLabels {
  /** The word for „nie odpowiedziano", for assistive technology. The glyph is a dash. */
  readonly blankLabel: string;
  /** What an aged-out recording's frame says instead of playing. */
  readonly expiredLabel: string;
}

export function useReadingLabels(): SurveyReadingLabels {
  const { t } = useTranslation();
  return {
    blankLabel: t('web:clientDetail.surveys.noAnswer'),
    expiredLabel: t('web:clientDetail.surveys.clipExpired'),
  };
}
